export enum CartActionState {
  Default = 'default',
  Updating = 'updating',
  Complete = 'complete',
}

export type Attribute = {
  key: string;
  value: string;
};

export type CartLineInput = {
  /** An array of key-value pairs that contains additional information about the merchandise line. */
  attributes?: Array<Attribute>;
  /** The identifier of the merchandise that the buyer intends to purchase. */
  merchandiseId: string;
  /** The quantity of the merchandise. */
  quantity?: number;
  /** The identifier of the selling plan that the merchandise is being purchased with. */
  sellingPlanId?: string;
};

export type CartActions = {
  cartState: CartActionState;
  errorMessage?: string;
  status?: CartStatus;
  onAddToCart: (products: Array<CartLineInput>) => void;
};

export enum CartStatus {
  uninitialized = 'uninitialized',
  fetching = 'fetching',
  creating = 'creating',
  updating = 'updating',
  idle = 'idle',
}
